import $ from "jquery";

const toggleClass = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            button: ".js-toggle-class",
        };

        $(document).on("click", el.button, function () {
            const targetEl = $(this).data("for");
            $(targetEl).toggleClass($(this).data("toggle_class"));
        });
    };

    init();
};

try {
    toggleClass();
} catch (error) {
    console.error("toggleClass: ", toggleClass);
}
